// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLightMeterModePeak_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.5657 4.55561C14.8413 4.10202 15 3.56954 15 3 15 2.89376 14.9945 2.78882 14.9837 2.68543 14.8265 1.17642 13.5506 0 12 0 10.4494 0 9.17353 1.17642 9.01629 2.68543 9.01602 2.68804 9.01575 2.69065 9.01549 2.69327 9.00525 2.79412 9 2.89645 9 3 9 3.60414 9.17858 4.16658 9.48584 4.6374 10.0212 5.45779 10.9473 6 12 6 13.0527 6 13.9788 5.45779 14.5142 4.6374 14.5318 4.61043 14.5489 4.58317 14.5657 4.55561ZM7.08518 3.92388C7.21271 4.60653 7.47895 5.24036 7.85354 5.79498 4.40014 8.9463 2 15.9126 2 24H0C0 15.0603 2.90843 7.36596 7.08518 3.92388ZM16.9148 3.92388C16.7873 4.60654 16.521 5.24036 16.1465 5.79498 19.5999 8.94631 22 15.9126 22 24H24C24 15.0603 21.0916 7.36596 16.9148 3.92388Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLightMeterModePeak is a generated icon component.
 */
let IconMedLightMeterModePeak = IconMedLightMeterModePeak_1 = class IconMedLightMeterModePeak extends IconBaseElement {
    render() {
        return html `${IconMedLightMeterModePeak_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLightMeterModePeak.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLightMeterModePeak = IconMedLightMeterModePeak_1 = __decorate([
    customElement('zui-icon-med-light-meter-mode-peak')
], IconMedLightMeterModePeak);
export { IconMedLightMeterModePeak };
